import { Create, Default, Detail,   List } from "./views";


const Module = {
    name: "setups",
    defaultRoutePath: "/cars/setup",
    menuItemScope: "fleet",
    menuItemName: "setups",

    routes: [
        {
            path: "/cars/setup",
            protected: true,
            children: [
                {
                    index: true,
                    path: "",
                    Component: Default,
                },
                {
                    path: "list",
                    Component: List,
                },
            ],
        },
    ],
    drawerRoutes: [
        {
            path: "list",
            Component: List,
        },
        {
            path: "detail",
            Component: Detail,
        },
        {
            path: "create",
            Component: Create,
        },
        
    ],
    
}

export default Module;
